module.exports = __webpack_public_path__ + "img/alan.cc9f8195.png";